module.exports = __webpack_public_path__ + "static/media/valor4_2.d0bd190f.png";